function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdobeIo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 192 192",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M77.749 42.134c1.157 27.686 11.572 35.67 27.002 55.113 19.417 24.595 34.075 38.438 45.969 41.657 17.809 4.764 27.645-10.302 10.287-17.834-17.36-7.533-48.22-5.151-66.22-2.383-29.253 4.7-50.277 13.07-66.543 31.355-14.272 15.839-1.607 27.686 12.666 13.907 13.051-12.233 30.474-46.034 37.61-61.808 9.516-20.99 20.188-39.661 18.806-64.256-1.382-24.595-20.348-18.8-19.577 4.25Z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 12,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdobeIo);
export default __webpack_public_path__ + "static/media/adobe-io.4ffad3396f65a231a7ca287f3d735012.svg";
export { ForwardRef as ReactComponent };